import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

import { FaqWidgetService } from '../../services/faq-widget.service';
import { HelpFaqActions } from '../../store/actions';
import { HelpFaqSelectors } from '../../store/selectors';

@Component({
  selector: 'app-faq-widget-host',
  templateUrl: './faq-widget-host.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class FaqWidgetHostComponent implements OnInit, OnDestroy {
  isOpen = false;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly faqWidgetService: FaqWidgetService,
    private readonly store: Store,
    private readonly cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  ngOnInit(): void {
    this.faqWidgetService.isOpen$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isOpen) => {
        this.isOpen = isOpen;
        this.cdr.detectChanges();
        if (isOpen) {
          this.document.body.classList.add('faq-open');
          this.loadFaqsIfNeeded();
        } else {
          this.document.body.classList.remove('faq-open');
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.document.body.classList.remove('faq-open');
  }

  protected onClose(): void {
    this.faqWidgetService.close();
  }

  private loadFaqsIfNeeded(): void {
    this.store
      .pipe(select(HelpFaqSelectors.getIsFaqLoaded), take(1))
      .subscribe((isLoaded) => {
        if (!isLoaded) {
          this.store.dispatch(HelpFaqActions.LoadFaqs());
        }
      });
  }
}
